/* unplugin-vue-components disabled */import script from "./industry-kpi-list.vue?vue&type=script&setup=true&lang=js"
export * from "./industry-kpi-list.vue?vue&type=script&setup=true&lang=js"

import "./industry-kpi-list.vue?vue&type=style&index=0&id=635109b9&lang=postcss"

const __exports__ = script;

export default __exports__